/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPageAuthzPolicyViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageAuthzPolicyViewQuery = { authzPolicies: Array<{ guid: string, name: string }> };


export const SettingsPageAuthzPolicyViewDocument = gql`
    query SettingsPageAuthzPolicyView {
  authzPolicies {
    guid
    name
  }
}
    `;

/**
 * __useSettingsPageAuthzPolicyViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageAuthzPolicyViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageAuthzPolicyViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageAuthzPolicyViewQuery();
 */
export function useSettingsPageAuthzPolicyViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables>(SettingsPageAuthzPolicyViewDocument, {}, options);
}
export function useSettingsPageAuthzPolicyViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables>(SettingsPageAuthzPolicyViewDocument, {}, options);
}
export type SettingsPageAuthzPolicyViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageAuthzPolicyViewQuery, SettingsPageAuthzPolicyViewQueryVariables>;